import { FieldErrors } from 'react-hook-form';
import { FinancialTransactionInputData } from '@/features/dashboard/financialTransactions/schemas/financialTransactionSchema.ts';

export const ALLOCATIONS_ERROR_ID = 'allocations-error';

/**
 * Baner przypisań czyta dwa kształty błędu i przewijanie musi czytać te same:
 * suma ponad kwotę siada pod `root` (jawna ścieżka `['allocations', 'root']`),
 * a `min(1)` na tablicy pod samym `allocations.message`.
 */
export const hasOnlyAllocationsError = (
  errors: FieldErrors<FinancialTransactionInputData>,
): boolean =>
  Object.keys(errors).length === 1 &&
  Boolean(errors.allocations?.root?.message ?? errors.allocations?.message);

/**
 * Do `onInvalid` z `handleSubmit`: baner sumy przypisań stoi na końcu modala
 * i po zablokowanym zapisie potrafi zostać pod zgięciem.
 *
 * Tylko gdy błąd sumy jest jedyny. RHF woła `onInvalid`, potem ogniskuje pierwsze
 * błędne pole — od razu i jeszcze raz przez `setTimeout` — a to przewinięcie
 * wypada po obu i by je nadpisało: kursor siedziałby w polu poza ekranem.
 *
 * Klatka zwłoki, bo RHF publikuje błędy do stanu dopiero po `onInvalid`: przy
 * pierwszym nieudanym zapisie banera nie ma jeszcze w drzewie.
 */
export const scrollToAllocationsError = (
  errors: FieldErrors<FinancialTransactionInputData>,
) => {
  if (!hasOnlyAllocationsError(errors)) return;

  requestAnimationFrame(() =>
    document
      .getElementById(ALLOCATIONS_ERROR_ID)
      ?.scrollIntoView({ block: 'center', behavior: 'smooth' }),
  );
};
